<!-- Construction incomplete section -->
<div class="row mb-3">
    <div class="col-6 offset-2">
        <pace-core-checkbox-input
            [(model)]="model.constructionIncomplete"
            (valueChange)="checkboxClick(model.constructionIncompleteText, model.constructionIncomplete.value)"
            [parentForm]="parentForm"
        >
        </pace-core-checkbox-input>
    </div>
</div>
<ng-container *ngIf="model.constructionIncomplete.value">
    <div class="row mb-3">
        <label class="col-2 col-form-label" translate="CONFIRMATION_INTERRUPTIONS_TEXT"></label>
        <div class="col-8">
            <pace-core-text-input
                [(model)]="model.constructionIncompleteText"
                [parentForm]="parentForm"
            ></pace-core-text-input>
        </div>
    </div>
    <hr class="separator" />
</ng-container>

<!-- Network not fully operational section -->
<div class="row mb-3">
    <div class="col-6 offset-2">
        <pace-core-checkbox-input
            [(model)]="model.networkNotFullyOperational"
            (valueChange)="checkboxClick(model.networkNotFullyOperationalText, model.networkNotFullyOperational.value)"
            [parentForm]="parentForm"
        >
        </pace-core-checkbox-input>
    </div>
</div>
<ng-container *ngIf="model.networkNotFullyOperational.value">
    <div class="row mb-3">
        <label class="col-2 col-form-label" translate="CONFIRMATION_INTERRUPTIONS_TEXT"></label>
        <div class="col-8">
            <pace-core-text-input
                [(model)]="model.networkNotFullyOperationalText"
                [parentForm]="parentForm"
            ></pace-core-text-input>
        </div>
    </div>
    <hr class="separator" />
</ng-container>

<!-- Service issues section -->
<div class="row mb-3">
    <div class="col-6 offset-2">
        <pace-core-checkbox-input
            [(model)]="model.serviceIssues"
            (valueChange)="checkboxClick(model.serviceIssuesText, model.serviceIssues.value)"
            [parentForm]="parentForm"
        >
        </pace-core-checkbox-input>
    </div>
</div>
<ng-container *ngIf="model.serviceIssues.value">
    <div class="row mb-3">
        <label class="col-2 col-form-label" translate="CONFIRMATION_INTERRUPTIONS_TEXT"></label>
        <div class="col-8">
            <pace-core-text-input [(model)]="model.serviceIssuesText" [parentForm]="parentForm"></pace-core-text-input>
        </div>
    </div>
    <hr class="separator" />
</ng-container>

<!-- Open issues section -->
<div class="row mb-3">
    <div class="col-6 offset-2">
        <pace-core-checkbox-input
            [(model)]="model.openIssues"
            (valueChange)="checkboxClick(model.openIssuesText, model.openIssues.value)"
            [parentForm]="parentForm"
        >
        </pace-core-checkbox-input>
    </div>
</div>
<ng-container *ngIf="model.openIssues.value">
    <div class="row mb-3">
        <label class="col-2 col-form-label" translate="CONFIRMATION_INTERRUPTIONS_TEXT"></label>
        <div class="col-8">
            <pace-core-text-input [(model)]="model.openIssuesText" [parentForm]="parentForm"></pace-core-text-input>
        </div>
    </div>
    <hr class="separator" />
</ng-container>

<!-- Equipment not fully operational section -->
<div class="row mb-3">
    <div class="col-6 offset-2">
        <pace-core-checkbox-input
            [(model)]="model.equipmentNotFullyOperational"
            (valueChange)="
                checkboxClick(model.equipmentNotFullyOperationalText, model.equipmentNotFullyOperational.value)
            "
            [parentForm]="parentForm"
        >
        </pace-core-checkbox-input>
    </div>
</div>
<ng-container *ngIf="model.equipmentNotFullyOperational.value">
    <div class="row mb-3">
        <label class="col-2 col-form-label" translate="CONFIRMATION_INTERRUPTIONS_TEXT"></label>
        <div class="col-8">
            <pace-core-text-input
                [(model)]="model.equipmentNotFullyOperationalText"
                [parentForm]="parentForm"
            ></pace-core-text-input>
        </div>
    </div>
    <hr class="separator" />
</ng-container>

<!-- State-Physicist inspection not complete section -->
<div class="row mb-3">
    <div class="col-6 offset-2">
        <pace-core-checkbox-input
            [(model)]="model.statePhysicistInspectionNotComplete"
            (valueChange)="
                checkboxClick(
                    model.statePhysicistInspectionNotCompleteText,
                    model.statePhysicistInspectionNotComplete.value
                )
            "
            [parentForm]="parentForm"
        >
        </pace-core-checkbox-input>
    </div>
</div>
<ng-container *ngIf="model.statePhysicistInspectionNotComplete.value">
    <div class="row mb-3">
        <label class="col-2 col-form-label" translate="CONFIRMATION_INTERRUPTIONS_TEXT"></label>
        <div class="col-8">
            <pace-core-text-input
                [(model)]="model.statePhysicistInspectionNotCompleteText"
                [parentForm]="parentForm"
            ></pace-core-text-input>
        </div>
    </div>
    <hr class="separator" />
</ng-container>

<!-- OEM issues section -->
<div class="row mb-3">
    <div class="col-6 offset-2">
        <pace-core-checkbox-input
            [(model)]="model.oemIssues"
            (valueChange)="checkboxClick(model.oemIssuesText, model.oemIssues.value)"
            [parentForm]="parentForm"
        >
        </pace-core-checkbox-input>
    </div>
</div>
<ng-container *ngIf="model.oemIssues.value">
    <div class="row mb-3">
        <label class="col-2 col-form-label" translate="CONFIRMATION_INTERRUPTIONS_TEXT"></label>
        <div class="col-8">
            <pace-core-text-input [(model)]="model.oemIssuesText" [parentForm]="parentForm"></pace-core-text-input>
        </div>
    </div>
    <hr class="separator" />
</ng-container>
